'use client';

import { c as _c } from "react/compiler-runtime";
import { Rating, Star } from '@smastrom/react-rating';
import '@smastrom/react-rating/style.css';
import Tooltip from '@/app/_components/Tooltip';
const starStyles = {
  itemShapes: Star,
  itemStrokeWidth: 0,
  activeFillColor: '#FCB600',
  inactiveFillColor: '#D1D5DB'
};
const ReviewStars = t0 => {
  const $ = _c(12);
  const {
    sub_product
  } = t0;
  const averageRating = sub_product?.review_stats?.average_rating || 0;
  const reviewCount = sub_product?.review_stats?.review_count || 0;
  const tooltipText = reviewCount > 0 ? `${averageRating} out of 5 stars from ${reviewCount} customer review${reviewCount !== 1 ? "s" : ""}` : "No reviews yet. Be the first to review this product.";
  const t1 = `${averageRating} out of 5 stars${reviewCount > 0 ? `, ${reviewCount} reviews` : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      maxWidth: 80
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== averageRating) {
    t3 = <Rating value={averageRating} readOnly={true} style={t2} itemStyles={starStyles} />;
    $[1] = averageRating;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== reviewCount) {
    t4 = reviewCount > 0 && <span className="text-xs text-light ml-1" aria-hidden="true">({reviewCount})</span>;
    $[3] = reviewCount;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t3 || $[7] !== t4) {
    t5 = <div className="flex items-center" aria-label={t1}>{t3}{t4}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5 || $[10] !== tooltipText) {
    t6 = <Tooltip content={tooltipText} side="bottom">{t5}</Tooltip>;
    $[9] = t5;
    $[10] = tooltipText;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default ReviewStars;